import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-27b8bdac"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header navbar-area" };
const _hoisted_2 = { class: "topbar" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "row justify-content-between" };
const _hoisted_5 = { class: "col-lg-4 col-md-4 col-12" };
const _hoisted_6 = { class: "top-start" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-menu" }, null, -1 /* HOISTED */));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-home" }, null, -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "d-none d-sm-inline" }, "Inicio", -1 /* HOISTED */));
const _hoisted_11 = {
    key: 0,
    class: "admin-title d-none d-md-inline ms-3"
};
const _hoisted_12 = {
    key: 1,
    class: "admin-title d-none d-md-inline ms-3"
};
const _hoisted_13 = { class: "col-lg-4 col-md-4 col-12" };
const _hoisted_14 = { class: "top-end" };
const _hoisted_15 = {
    key: 0,
    class: "user"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-user" }, null, -1 /* HOISTED */));
const _hoisted_17 = {
    key: 1,
    class: "user-login"
};
const _hoisted_18 = {
    key: 2,
    class: "user"
};
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-user" }, null, -1 /* HOISTED */));
const _hoisted_20 = { key: 0 };
const _hoisted_21 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createCommentVNode(" Start Header Area "),
        _createElementVNode("header", _hoisted_1, [
            _createCommentVNode(" Start Topbar "),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("button", {
                                    class: "mobile-toggle",
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => ($setup.toggleMenu && $setup.toggleMenu(...args))),
                                    "aria-label": "Menu"
                                }, _hoisted_8),
                                _createCommentVNode(" Botón de Inicio "),
                                _createElementVNode("a", {
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => ($setup.goToHome && $setup.goToHome(...args))),
                                    class: "home-link"
                                }, [
                                    _hoisted_9,
                                    _createTextVNode("  "),
                                    _hoisted_10
                                ]),
                                ($setup.user && $setup.user.role === '1')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Vendedor"))
                                    : _createCommentVNode("v-if", true),
                                ($setup.user && $setup.user.role === '2')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Comprador"))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                (!$setup.user)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createTextVNode(" Hola! ")
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (!$setup.user)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[2] || (_cache[2] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.goToLogin && $setup.goToLogin(...args))),
                                                style: { "cursor": "pointer" }
                                            }, "Iniciar Sesión")
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[3] || (_cache[3] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.goToRegister && $setup.goToRegister(...args))),
                                                style: { "cursor": "pointer" }
                                            }, "Registrarse")
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                ($setup.user)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _hoisted_19,
                                        _createTextVNode(" " + _toDisplayString($setup.user.nombre) + " ", 1 /* TEXT */),
                                        ($setup.user.role === '1')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, " (Vendedor)"))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.user.role === '2')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, " (Comprador)"))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("a", {
                                            onClick: _cache[4] || (_cache[4] =
                                                //@ts-ignore
                                                (...args) => ($setup.logout && $setup.logout(...args))),
                                            class: "ms-4",
                                            style: { "cursor": "pointer", "color": "white" }
                                        }, "Cerrar Sesión")
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ])
            ]),
            _createCommentVNode(" End Topbar ")
        ]),
        _createCommentVNode(" End Header Area ")
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
}
